import { cn } from "@/lib/utils";

export interface TbWordmarkProps {
  className?: string;
}

/**
 * The official logotype (canon §20): one file, viewBox 2148.73 × 471.49 (4,56 : 1), the same file
 * every design draws (`assets/tb_wordmark.svg`). The mask asset stays in `public/` rather than
 * being inlined: CSS masking needs a URL, and keeping it a separate file means the path data is
 * cached once instead of shipping in every RSC payload that renders the wordmark.
 */
const MASK = "url('/images/brand/tb-wordmark.svg')";

/**
 * Brand wordmark "TANIA BULHÕES".
 *
 * A CSS mask over `currentColor`, not an `<img>`, so one vector serves any
 * surface: colour comes from a `text-*` utility, width from `w-*`, and the
 * logotype's ratio is baked in.
 */
export function TbWordmark({ className }: TbWordmarkProps) {
  return (
    <span
      role="img"
      aria-label="Tania Bulhões"
      className={cn("block aspect-[2148.73/471.49] bg-current", className)}
      style={{
        WebkitMaskImage: MASK,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "left center",
        WebkitMaskSize: "contain",
        maskImage: MASK,
        maskRepeat: "no-repeat",
        maskPosition: "left center",
        maskSize: "contain",
      }}
    />
  );
}
